import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-youtube-embed',
  imports: [NgClass],
  templateUrl: './youtube-embed.component.html',
  styleUrl: './youtube-embed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeEmbedComponent {


  styleClass = input<string>("")

  youtubeVideoId = input.required<string>()

  embedUrl = computed(() => this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + this.youtubeVideoId()))


  constructor(private sanitizer: DomSanitizer) {}
}
